import api from './api';

// Subscription API
export const subscriptionApi = {
  // Get current subscription status
  getStatus() {
    return api.get('/subscription');
  },

  // Get usage/limits
  getUsage() {
    return api.get('/subscription/usage');
  },

  // Get available plans
  getPlans() {
    return api.get('/plans');
  },

  // Subscribe to a plan
  subscribe(data) {
    return api.post('/subscription/subscribe', data);
  },

  // Change plan
  changePlan(data) {
    return api.post('/subscription/change-plan', data);
  },

  // Cancel subscription
  cancel(data = {}) {
    return api.post('/subscription/cancel', data);
  },

  // Resume subscription
  resume() {
    return api.post('/subscription/resume');
  },

  // Get invoices
  getInvoices(params = {}) {
    return api.get('/subscription/invoices', { params });
  }
};

// Company API
export const companyApi = {
  // Get company details
  get() {
    return api.get('/company');
  },

  // Update company
  update(data) {
    return api.put('/company', data);
  },

  // Get company stats
  getStats() {
    return api.get('/company/stats');
  },

  // Update branding
  updateBranding(data) {
    return api.put('/company/branding', data);
  },

  // Update domain settings
  updateDomain(data) {
    return api.put('/company/domain', data);
  }
};

export default {
  subscription: subscriptionApi,
  company: companyApi
};
